module.exports = __webpack_public_path__ + "media/images/menu-slider-1-999c1546bd5633565cd3f184de5f6b40.png";